import React, { useEffect, useRef, useState } from 'react';
import './Testimonials.css';
import { useI18n } from '../../i18n/I18n';

type Testimonial = {
  id: string;
  name: string;
  text: string;
  rating: number;
  approved: boolean;
  date: number;
};

const DEFAULTS: Testimonial[] = [
  { id: 'd1', name: 'A. Demir', text: 'Araç teslimi hızlıydı, uzun dönem süreçte hep destek oldular.', rating: 5, approved: true, date: 1710000000000 },
  { id: 'd2', name: 'B. Yılmaz', text: 'Kurumsal sözleşme ve faturalama tarafı çok profesyoneldi.', rating: 5, approved: true, date: 1710100000000 },
  { id: 'd3', name: 'C. Kaya', text: 'Temiz araç, şeffaf koşullar. Tavsiye ederim.', rating: 4, approved: true, date: 1710200000000 },
];

// Eklenebilir yorumlar ve yönetim kaldırıldı; yalnızca varsayılan onaylı yorumlar gösterilir

const StarRow: React.FC<{ rating: number }> = ({ rating }) => (
  <div className="stars">{'★★★★★'.slice(0, rating)}{'☆☆☆☆☆'.slice(0, 5 - rating)}</div>
);

const readItems = (): Testimonial[] => DEFAULTS;

const Testimonials: React.FC = () => {
  const [items, setItems] = useState<Testimonial[]>([]);
  // Ekleme ve moderasyon kaldırıldı; yalnızca gösterim
  const scrollerRef = useRef<HTMLDivElement | null>(null);
  const { t } = useI18n();

  useEffect(() => {
    setItems(readItems());
  }, []);

  // Modal/odak yönetimi kaldırıldı

  const approvedItems = items.filter((i) => i.approved);

  const scrollBy = (dx: number) => {
    if (!scrollerRef.current) return;
    scrollerRef.current.scrollBy({ left: dx, behavior: 'smooth' });
  };

  return (
    <section className="testimonials">
      <div className="testi-container">
        <h2>{t('testimonials.title')}</h2>

        <div className="testi-row">
          <button className="nav-arrow left" aria-label="Sola kaydır" onClick={() => scrollBy(-300)}>‹</button>
          <div className="scroller" ref={scrollerRef}>
            {approvedItems.map((t) => (
              <article key={t.id} className="testi-card">
                <StarRow rating={t.rating} />
                <p className="testi-text">“{t.text}”</p>
                <div className="testi-name">{t.name}</div>
              </article>
            ))}
          </div>
          <button className="nav-arrow right" aria-label="Sağa kaydır" onClick={() => scrollBy(300)}>›</button>
        </div>
      </div>

    </section>
  );
};

export default Testimonials; 